import { RootStore } from './RootStore';

/**
 * Инстанс `RootStore`
 */
export const rootStore = new RootStore();

/**
 * Глобальный стор нотификаций
 */
export const notificationsStore = rootStore.notificationsStore;

/**
 * Глобальный стор исполнений анализов
 */
export const analysisExecutionsStore = rootStore.analysisExecutionsStore;

/**
 * Глобальный стор query-параметров
 */
export const queryParamsStore = rootStore.queryParamsStore;

/**
 * Глобальный стор галочки «Ускоренный режим»
 */
export const fastModeStore = rootStore.fastModeStore;

/**
 * Глобальный стор сессии пользователя
 */
export const sessionStore = rootStore.sessionStore;

/**
 * Глобальный стор организаций
 */
export const organizationsStore = rootStore.organizationsStore;

/**
 * Глобальный стор анализов документов
 */
export const analysesStore = rootStore.analysesStore;

/**
 * Стор страницы неавторизованного пользователя
 */
export const unauthorizedPageStore = rootStore.unauthorizedPageStore;
